<template>
  <div>
    <on-click-outside :do="close" v-if="$route.meta.layout !== 'players'">
      <div class="text-main-text" :class="{'is-active': showComponent}">
        <div ref="button" class="p-1 cursor-pointer" @click.stop.prevent="switchPopper">
          <div
            class="rounded-full w-8 h-8 ml-3 flex flex-row items-center justify-center overflow-hidden"
            :class="[`${borderColor}` , {'border':isPhone === 'desktop'}]"
          >
            <img class="avatar h-full w-full" v-if="user.avatar_url" :src="user.avatar_url" alt="" />
            <img
              class
              v-if="isPhone === 'desktop'&& !user.avatar_url"
              src="@/assets/SVG/fill_1_white.svg"
              alt=""
            />
            <img
              v-if="isPhone === 'isPhone'&& !user.avatar_url"
              src="@/assets/SVG/mobile-profile-logo-white.svg"
              alt
            />
          </div>
        </div>

        <div
          ref="panel"
          v-if="showComponent"
          class="absolute user-pop rounded-lg sm:flex sm:flex-col bg-white shadow-md z-50 overflow-hidden text-main-text"
        >
          <div class="flex">
            <font-awesome-icon
              :icon="['fal', 'times']"
              class="absolute text-brand-grey-light pin-t pin-r mr-8 mt-4 cursor-pointer text-2xl z-50"
              @click="close"
            ></font-awesome-icon>

            <div class="flex items-center" v-if="isPhone !== 'isPhone'">
              <div
                class="border-2 rounded-full w-16 h-16 flex flex-row items-center justify-center relative"
              >
                <div class="overflow-hidden rounded-full w-full h-full relative flex items-center">
                  <img class="avatar h-full w-fu" v-if="user.avatar_url" :src="user.avatar_url" alt=""/>
                  <img class="h-8 ml-4" v-else src="@/assets/SVG/avatar.svg" alt=""/>
                </div>

                <div
                  title="Удалить изображение"
                  @click="delete_avatar"
                  class="cursor-pointer bg-red-dark absolute w-5 h-5 rounded-full border border-white text-white flex justify-center items-center delete-avatar z-10"
                >
                  <font-awesome-icon class="text-xs" :icon="['fas', 'plus']"></font-awesome-icon>
                </div>

                <div
                  v-if="!user.avatar_url"
                  title="Добавить изображение"
                  class="cursor-pointer bg-brand-green absolute w-5 h-5 rounded-full border border-white text-white flex justify-center items-center add-avatar z-10"
                >
                  <input
                    ref="file"
                    class="absolute pin opacity-0"
                    @change="uploadAvatar"
                    type="file"
                    accept="image/*"
                  />
                  <font-awesome-icon class="text-xs" :icon="['fas', 'plus']"></font-awesome-icon>
                </div>
              </div>
            </div>
            <div class="flex flex-col w-full justify-center" :class="{'p-4':isPhone !== 'isPhone'}">
              <p class="text-lg font-bold mb-1">{{user.name}}</p>
              <p class="text-mxs font-medium text-brand-darker-light">{{user.email}}</p>
            </div>
          </div>
          <div class="flex mt-4" :class="{'mt-6':isPhone !== 'isPhone'}">
            <button
              @click.stop.prevent="cabinet"
              class="bg-brand-light mr-3 outline-none hover-up text-white font-bold rounded-full hover:bg-brand-yellow hover:text-main-text py-3 px-6 text-xm md:px-12 sm:text-sm"
            >Личный кабинет</button>
            <button
              @click.stop.prevent="logout"
              class="outline-none w-1/3 hover-up text-grey-darkest font-bold rounded-full border border-brand-grey-light py-3 text-xs sm:text-sm hover:bg-brand-yellow hover:border-brand-yellow"
            >Выйти</button>
          </div>
        </div>
      </div>
    </on-click-outside>
    <img
      class="cursor-pointer min-w-4 ml-4"
      v-if="$route.meta.layout === 'players'"
      @click.stop.prevent="logout"
      src="@/assets/SVG/account-logout.svg"
    />
    <NewsHandler v-if="user.role === 'player'" :url="'/api/players/news'" :type="'Player'"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import * as Cookies from 'js-cookie';
import Popper from 'popper.js';
import client from '@/clients/partners';
import players from '@/clients/player';
import NewsHandler from '../views/partners/news/newsHandler.vue';
import OnClickOutside from '../views/OnClickOutside.vue';

export default {
  name: 'user-modal',
  components: { OnClickOutside, NewsHandler },
  props: {
    borderColor: {
      type: String,
      default: 'text-main-text',
    },
    isPhone: {
      type: String,
      default: 'desktop',
    },
  },

  data() {
    return {
      showComponent: false,
      showConfirm: false,
      player_service: false,
      client_service: false,
    };
  },
  beforeDestroy() {
    if (this.popper !== undefined) {
      this.popper.destroy();
    }
  },
  methods: {
    ...mapActions(['refreshUser']),
    disInput() {
      this.$emit('disableInput');
      this.close();
    },
    switchPopper() {
      if (!Object.keys(this.user).length) {
        this.$emit('registration_open');
        return;
      }
      this.showComponent = !this.showComponent;
      this.showConfirm = false;
      if (this.showComponent) {
        this.$nextTick(() => {
          this.setupPopper();
        });
      }
    },
    cabinet() {
      if (this.user.role === 'player') {
        this.$router.push('/players/my-games');
        if (window && window.BigBrother) window.BigBrother.reachGoal('open_cabinet_portal');
      } else this.$router.push('/partners');
    },
    logout() {
      Cookies.remove('mozgoAuth', { domain: 'mozgo.com' });
      this.$store.dispatch('logout');
      this.showComponent = !this.showComponent;
      this.$router.push('/');
    },

    setupPopper() {
      this.popper = undefined;
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.button, this.$refs.panel, {
          placement: 'bottom-end',
          positionFixed: false,
        });
      } else {
        this.popper.scheduleUpdate();
      }
    },
    close() {
      if (!this.showComponent) {
        return;
      }
      this.showComponent = false;
    },
    updateUser() {
      if (this.user.role === 'player') this.refreshUser(players);
      else this.refreshUser(client);
    },
    uploadAvatar(e) {
      const file = e.target.files[0];
      const data = new FormData();
      data.append('avatar', file);
      client.post('/avatar', data).then(() => {
        this.updateUser();
        this.$refs.file.value = '';
      });
    },
    delete_avatar() {
      client.delete('/avatar').then(() => {
        this.updateUser();
        this.$refs.file.value = '';
      });
    },
  },
  computed: {
    user() {
      return this.$store.getters.userInfo || {};
    },
  },
};
</script>

<style scoped lang="less">
.button-class {
  color: white;
  border-radius: 1rem;
}
.user-pop {
  width: 400px;
  white-space: nowrap;
  padding: 2rem 1rem;
}
.log-out {
  transition: all 0.3s ease-in-out;
}
.avatar {
  width: 110%;
  height: 110%;
  object-fit: cover;
  object-position: center center;
}
.delete-avatar,
.add-avatar {
  top: -5px;
  right: 0;
  transform: rotate(45deg);
  transition: all 0.3s ease;
}
.add-avatar {
  transform: rotate(0);
}
.delete-avatar:hover,
.add-avatar:hover {
  transform: scale(1.2), rotate(-45deg);
}
@media (max-width: 768px) {
.user-pop{
  width: 21rem;
  z-index: 51 !important;
  left: 1rem !important;
}
}
@media (max-width: 360px) {
.user-pop{
  width: 20.5rem;
  z-index: 51 !important;
  left: 0.7rem !important;
}
}
@media (max-width: 330px) {
.user-pop{
  width: 18.5rem;
  z-index: 51 !important;
  left: 0.5rem !important;
}
}
</style>
